import { render, staticRenderFns } from "./WrapperExpandButton.vue?vue&type=template&id=45a9771a&"
import script from "./WrapperExpandButton.vue?vue&type=script&lang=js&"
export * from "./WrapperExpandButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports